import React, { useState } from 'react';
import Icon from '../AppIcon';

const CustomizationPanel = ({ isExpanded = false, onToggle }) => {
  const [localExpanded, setLocalExpanded] = useState(isExpanded);

  const handleToggle = () => {
    const newState = !localExpanded;
    setLocalExpanded(newState);
    if (onToggle) {
      onToggle(newState);
    }
  };

  return (
    <div className="bg-card rounded-xl border border-border overflow-hidden">
      <button
        onClick={handleToggle}
        className="w-full px-8 py-4 flex items-center justify-between bg-muted/30 hover:bg-muted/50 transition-smooth"
      >
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 rounded-lg bg-accent/10 flex items-center justify-center">
            <Icon name="Palette" size={18} color="var(--color-accent)" strokeWidth={2} />
          </div>
          <div className="text-left">
            <h3 className="text-base font-heading font-semibold text-foreground">
              Advanced Customization
            </h3>
            <p className="text-xs font-caption text-muted-foreground mt-0.5">
              Customize colors, logo, and styling options
            </p>
          </div>
        </div>
        <Icon
          name={localExpanded ? 'ChevronUp' : 'ChevronDown'}
          size={20}
          color="var(--color-muted-foreground)"
          strokeWidth={2}
          className="transition-smooth"
        />
      </button>

      <div
        className={`
          overflow-hidden transition-all duration-250 ease-smooth
          ${localExpanded ? 'max-h-[2000px] opacity-100' : 'max-h-0 opacity-0'}
        `}
      >
        <div className="p-8 space-y-6 border-t border-border">
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-caption font-medium text-foreground mb-2">
                Foreground Color
              </label>
              <div className="flex items-center gap-3">
                <input
                  type="color"
                  defaultValue="#1E293B"
                  className="w-12 h-12 rounded-lg border-2 border-border cursor-pointer"
                />
                <input
                  type="text"
                  defaultValue="#1E293B"
                  placeholder="#000000"
                  className="flex-1 px-4 py-2.5 rounded-lg border border-input bg-background text-foreground font-mono text-sm focus:outline-none focus:ring-2 focus:ring-ring"
                />
              </div>
            </div>

            <div>
              <label className="block text-sm font-caption font-medium text-foreground mb-2">
                Background Color
              </label>
              <div className="flex items-center gap-3">
                <input
                  type="color"
                  defaultValue="#FFFFFF"
                  className="w-12 h-12 rounded-lg border-2 border-border cursor-pointer"
                />
                <input
                  type="text"
                  defaultValue="#FFFFFF"
                  placeholder="#FFFFFF"
                  className="flex-1 px-4 py-2.5 rounded-lg border border-input bg-background text-foreground font-mono text-sm focus:outline-none focus:ring-2 focus:ring-ring"
                />
              </div>
            </div>
          </div>

          <div className="pt-4 border-t border-border">
            <label className="block text-sm font-caption font-medium text-foreground mb-2">
              Add Logo (Optional)
            </label>
            <div className="relative">
              <input
                type="file"
                accept="image/*"
                className="hidden"
                id="logo-upload"
              />
              <label
                htmlFor="logo-upload"
                className="flex items-center justify-center gap-2 px-6 py-3 rounded-lg border-2 border-dashed border-border bg-muted/30 hover:bg-muted/50 cursor-pointer transition-smooth"
              >
                <Icon name="Upload" size={20} color="var(--color-muted-foreground)" strokeWidth={2} />
                <span className="text-sm font-caption font-medium text-muted-foreground">
                  Upload Logo Image
                </span>
              </label>
            </div>
            <p className="text-xs font-caption text-muted-foreground mt-2">
              Recommended: Square image, PNG format, max 2MB
            </p>
          </div>

          <div className="pt-4 border-t border-border space-y-4">
            <div>
              <label className="block text-sm font-caption font-medium text-foreground mb-2">
                Error Correction Level
              </label>
              <select className="w-full px-4 py-2.5 rounded-lg border border-input bg-background text-foreground text-sm focus:outline-none focus:ring-2 focus:ring-ring">
                <option value="L">Low (7% recovery)</option>
                <option value="M" selected>Medium (15% recovery)</option>
                <option value="Q">Quartile (25% recovery)</option>
                <option value="H">High (30% recovery)</option>
              </select>
            </div>

            <div>
              <label className="block text-sm font-caption font-medium text-foreground mb-2">
                QR Code Size
              </label>
              <div className="flex items-center gap-4">
                <input
                  type="range"
                  min="200"
                  max="1000"
                  step="50"
                  defaultValue="400"
                  className="flex-1"
                />
                <span className="text-sm font-mono text-foreground font-medium w-16 text-right">
                  400px
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomizationPanel;